import { Input, Select } from "antd";
import React, { useEffect, useState } from "react";

import { BsPlus } from "react-icons/bs";

import "./style.scss";
import CustomTable from "../../../assets/component/table";

const tableData = [
    { key: "ESG001", username: 'Test 1', role: "Admin", email: "admin@gmail.com", memberOfTeam: true },
    { key: "ESG002", username: 'Test 2', role: "Group Admin", email: "groupadmin@gmail.com", memberOfTeam: false },
    { key: "ESG003", username: 'Test 3', role: "User", email: "user@gmail.com", memberOfTeam: true },
]

const handleAction = () => {
}

const UserSection = () => {

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(50);
    const [loading, setLoading] = useState(false);
    const [formattedTableData, setFormattedTableData] = useState({
        dataSource: [],
        columns: []
    });

    const tableHeaderData = [
        {
            title: "User Name",
            key: "username",
            dataIndex: "username",
            width: "30%",
            sorter: {
                compare: (a, b) => a.username.localeCompare(b.username),
            },
            render: (_, { key, username }) => {
                if (key === "input") {
                    return (
                        <div>
                            <Input className="user-input" placeholder="Enter username" />
                        </div>
                    )
                }
                return <div>{username}</div>
            }
        },
        {
            title: "Role",
            key: "role",
            dataIndex: "role",
            width: "30%",
            sorter: {
                compare: (a, b) => a.role.localeCompare(b.role),
            },
            render: (_, { key, role }) => {
                const roles = [
                    { value: "admin", label: "Admin" },
                    { value: "team admin", label: "Team Admin" },
                    { value: "user", label: "User" },
                ];
                if (key === 'input') {
                    return (
                        <div>
                            <Select
                                placeholder="Select role"
                                className="role-select"
                                options={roles}
                                showSearch
                                allowClear
                                filterOption={(input, option) =>option?.label?.toLowerCase()?.includes(input?.toLowerCase())}
                            />

                        </div>
                    )
                }
                return <div>{role}</div>
            }
        },
        {
            title: "Email",
            key: "email",
            dataIndex: "email",
            width: "25%",
            sorter: {
                compare: (a, b) => a.email.localeCompare(b.email),
            },
            render: (_, { key, email }) => {
                if (key === "input") {
                    return (
                        <div className="input-field">
                            <Input className="email-input" placeholder="Enter email" />
                        </div>
                    )
                }
                return <div style={{ backgroundColor: "#fff" }}>{email}</div>
            }
        },
        {
            title: "Action",
            key: "action",
            dataIndex: "action",
            width: "15%",
            render: (_, { memberOfTeam }) => {
                if (memberOfTeam !== undefined) {
                    return (
                        <div onClick={() => handleAction()} className={`btn ${memberOfTeam ? 'revoke-button' : 'invite-button'}`}>{memberOfTeam ? "Revoke" : "Invite"}</div>
                    )
                }
                return (
                    <div className="button-wrapper">
                        <div className="btn add-btn">Add</div>
                        <div className="btn cancel-btn"
                            onClick={() => cancelAddUser()}
                        >Cancel</div>
                    </div>
                );

            }
        },
    ]


    const handleAddUser = () => {
        if (formattedTableData?.dataSource?.at(-1).key !== 'input') {
            setFormattedTableData(prevValue => {
                const addData = { key: "input", username: 'Test 3', role: "User", email: "user@gmail.com" }
                return { ...prevValue, dataSource: [...formattedTableData.dataSource, addData] };
            })
        }
    }

    const cancelAddUser = () => {
        setFormattedTableData(prevValue => {
            if (prevValue?.dataSource?.at(-1).key === 'input') {
                const newDataSource = prevValue.dataSource.slice(0, -1);
                return { ...prevValue, dataSource: newDataSource };
            } else {
                return prevValue;
            }
        })
    }

    const setData = () => {
        setFormattedTableData({ dataSource: [...tableData], columns: [...tableHeaderData] });
    }

    useEffect(() => {
        setData();
    }, [])

    return (
        <div className="user-details-section">
            <div className="wrapper">
                <div className="title-section">Users</div>
                <div className="btn add-btn" onClick={() => handleAddUser()}><BsPlus /> Add User</div>
            </div>
            <div className="source-list-table-section">
                <CustomTable
                    page={page}
                    limit={limit}
                    setPage={setPage}
                    setLimit={setLimit}
                    tableData={formattedTableData}
                    isLoading={loading}
                />
            </div>
        </div>
    )
}

export default UserSection;